import { Node } from '@tiptap/core'

export const ChartImage = Node.create({
  name: 'chart_image',

  group: 'block',
  atom: true,
  selectable: true,
  isolating: true,

  addAttributes() {
    return {
      image_id: { default: null },
      url: { default: null },
      caption: { default: null },
      uploaded_at: { default: null },
    }
  },

  parseHTML() {
    return [{ tag: 'chart-image' }]
  },

  renderHTML() {
    return ['chart-image', {}]
  },

  addNodeView() 
  {
    return ({ node, editor, getPos }) => {
      const dom = document.createElement('chart-image')
      dom.className = 'chart_image'

      const img = document.createElement('img')
      img.src = node.attrs.url
      img.alt = node.attrs.caption || 'Chart Image'
      img.className = 'chart_image_img'

      dom.appendChild(img)

      if (node.attrs.caption) {
        const caption = document.createElement('div')
        caption.className = 'chart_image_caption'
        caption.textContent = node.attrs.caption
        dom.appendChild(caption)
      }

      // 🔒 DISPLAY MODE — NO CONTROLS, NO SELECTION
      if (editor.storage.editor_mode === 'display') {
        dom.setAttribute('contenteditable', 'false')
        return { dom }
      }

      // ✏️ EDIT MODE CONTROLS
      const remove = document.createElement('button')
      remove.className = 'chart_image_remove'
      remove.textContent = '×'
      remove.type = 'button'

      remove.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()

        editor.commands.command(({ tr }) => {
          tr.delete(getPos(), getPos() + node.nodeSize)
          return true
        })
      })

      dom.appendChild(remove)

      return { dom }
    }
  }

})
